import { useEffect } from "react";
import { clearChunkReloadFlag } from "../chunkError";

export function ChunkReloadReset() {
  useEffect(() => {
    clearChunkReloadFlag();
  }, []);

  return null;
}
